// Widget Scripts
import headerButton from './js/widgets/headerButton.js';
import vimeoWidget from './js/widgets/vimeoWidget.js';
import eventsWidget from './js/widgets/eventsWidget.js';
import signupWidget from './js/widgets/signupWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import cardWidget7 from './js/widgets/cardsWidget.js';
import staticManagedSponsors from './js/widgets/sponsorsStatic.js';
import sponsors from './js/widgets/sponsors.js';
import footerGallery from './js/widgets/footerGallery.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  headerButton();

  if (globalThis.location.pathname === '/') {
    vimeoWidget();
    seoWidget();
    eventsWidget();
    signupWidget();
    cardWidget7();
    staticManagedSponsors();
    sponsors();
    footerGallery();
  }
});
